/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proc_ExecuteInputs */

const en_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXECUTE`)
};

const ar_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التنفيذ`)
};

const bn_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক্সিকিউট`)
};

const de_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXECUTE`)
};

const es_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXECUTE`)
};

const fr_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXECUTE`)
};

const pt_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXECUTE`)
};

const zh_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXECUTE`)
};

const tr_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXECUTE`)
};

const ru_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXECUTE`)
};

const pl_proc_execute = /** @type {(inputs: Proc_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXECUTE`)
};

/**
* | output |
* | --- |
* | "EXECUTE" |
*
* @param {Proc_ExecuteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const proc_execute = /** @type {((inputs?: Proc_ExecuteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proc_ExecuteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_proc_execute(inputs)
	if (locale === "bn") return bn_proc_execute(inputs)
	if (locale === "de") return de_proc_execute(inputs)
	if (locale === "es") return es_proc_execute(inputs)
	if (locale === "fr") return fr_proc_execute(inputs)
	if (locale === "pt") return pt_proc_execute(inputs)
	if (locale === "zh") return zh_proc_execute(inputs)
	if (locale === "tr") return tr_proc_execute(inputs)
	if (locale === "ru") return ru_proc_execute(inputs)
	if (locale === "pl") return pl_proc_execute(inputs)
	return en_proc_execute(inputs)
});